import React from "react";
import { Clock, Check } from "lucide-react";
import DateField from "../DateField";
import { Section, StepBadge } from "./ui";

function parseDate(value) {
  if (!value) return null;
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export default function DateStep({ state, set }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const pickupDate = parseDate(state.pickup);

  return (
    <Section>
      <StepBadge n={2} title="Fechas de alquiler" subtitle="Recogida y devolución" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-semibold text-[#2a1a1e] mb-1.5">Recogida</label>
          <div className="flex gap-2">
            <DateField
              className="flex-1"
              placeholder="Fecha"
              value={state.pickup}
              minDate={today}
              onChange={(v) => set({ pickup: v })}
            />
            <input
              type="time"
              className="veysa-input w-[7.5rem]"
              value={state.pickupTime}
              step="900"
              onChange={(e) => set({ pickupTime: e.target.value })}
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#2a1a1e] mb-1.5">Devolución</label>
          <div className="flex gap-2">
            <DateField
              className="flex-1"
              placeholder="Fecha"
              value={state.ret}
              minDate={pickupDate || today}
              onChange={(v) => set({ ret: v })}
            />
            <input
              type="time"
              className="veysa-input w-[7.5rem]"
              value={state.retTime}
              step="900"
              onChange={(e) => set({ retTime: e.target.value })}
            />
          </div>
        </div>
      </div>
      <p className="text-xs text-[#9b8388] mt-2 inline-flex items-center gap-1.5">
        <Clock className="w-3.5 h-3.5 text-[#631024]" />
        Horario: L–V 8:30–14:00 y 15:00–20:00 · Sáb 8:30–14:00 · Dom cerrado.
      </p>
      <label className="mt-4 flex items-center gap-2.5 cursor-pointer select-none">
        <span
          className={`w-5 h-5 rounded-md border flex items-center justify-center transition-colors ${
            state.outOfHours ? "bg-[#631024] border-[#631024]" : "bg-white border-[#d9c3c8]"
          }`}
          onClick={() => set({ outOfHours: !state.outOfHours })}
        >
          {state.outOfHours && <Check className="w-3.5 h-3.5 text-white" />}
        </span>
        <span className="text-sm text-[#6d5a5e] inline-flex items-center gap-1.5">
          <Clock className="w-4 h-4 text-[#631024]" /> Entrega/recogida fuera de horario (+35 €)
        </span>
      </label>
    </Section>
  );
}
